<template>
  <div class="only-category">
    <b-overlay :show="loading">
      <div class="row no-gutters only-category__grid">
        <div
          :class="[categoryColumnClass, 'only-category__column']"
          v-for="c in category"
          :key="c._id"
          :id="`cat-widget-${c._id}`"
        >
          <div
            class="category click only-category__card"
            :class="{ 'only-category__card--showcase': isShowcase }"
            @click="go(c._id)"
            @keydown.enter.prevent="go(c._id)"
            @keydown.space.prevent="go(c._id)"
            role="link"
            tabindex="0"
            :aria-label="`Ver categoría ${c.name}`"
          >
            <div class="only-category__content">
              <small v-if="!isShowcase" class="only-category__eyebrow">Explorar categoría</small>
              <h4 class="text-center only-category__title">{{ c.name }}</h4>
              <span v-if="isShowcase" class="only-category__all-link">
                Ver todas <span aria-hidden="true">&rarr;</span>
              </span>
              <span v-else class="only-category__arrow" aria-hidden="true">
                <b-icon icon="arrow-up-right"></b-icon>
              </span>
            </div>
            <div
              class="category-img only-category__image"
              aria-hidden="true"
              :style="categoryImageStyle(c)"
            ></div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  props: ["id", "params", "itemsPerRow", "categoryTemplate"],
  data() {
    return {
      products: [],
      loading: true,
      category: [],
    };
  },
  computed: {
    isShowcase() {
      return this.categoryTemplate === "showcase";
    },
    normalizedItemsPerRow() {
      const value = Number(this.itemsPerRow || 2);
      if ([1, 2, 3, 4].includes(value)) return value;
      return 2;
    },
    categoryColumnClass() {
      if (this.isShowcase) return "col-12 col-sm-6 col-lg-3 p-1";
      const base = "col-12 p-1";
      if (this.normalizedItemsPerRow === 1) return `${base} col-md-12`;
      if (this.normalizedItemsPerRow === 2) return `${base} col-md-6`;
      if (this.normalizedItemsPerRow === 3) return `${base} col-md-4`;
      return `${base} col-md-6 col-lg-3`;
    },
  },
  mounted() {
    console.log("Mounted category", this.params);
    this.load();
  },
  methods: {
    go(cid) {
      return this.$router.push(this.getLink("menu") + "?c=" + cid);
    },
    categoryImageStyle(category) {
      return category && category.image_url
        ? { backgroundImage: `url("${category.image_url}")` }
        : {};
    },
    load() {
      let { _id } = this.$store.state.info;
      let cid = this.id;

      let query = {
        order: "createdAt",
        limit: 4,
      };
      if (cid) query.category = cid;
      if (this.params) {
        let params = this.params.split(",");
        params.forEach((p) => {
          let [key, value] = p.split("=");
          query[key] = value;
        });
      }

      const u = new URLSearchParams(query).toString();

      this.$http
        .get(`${_id}/category?${u}`)
        .then((res) => {
          this.category = res.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.only-category__column {
  padding: 0.45rem;
}

.only-category__card {
  position: relative;
  display: flex;
  min-height: clamp(170px, 21vw, 270px);
  height: 100%;
  align-items: flex-end;
  overflow: hidden;
  padding: clamp(1.15rem, 2.6vw, 2rem);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 20px;
  background: #17231c;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.16);
  isolation: isolate;
  cursor: pointer;
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.only-category__card::before {
  position: absolute;
  z-index: 1;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(8, 15, 11, 0.08) 0%,
    rgba(8, 15, 11, 0.12) 32%,
    rgba(8, 15, 11, 0.78) 100%
  );
  content: "";
  pointer-events: none;
  transition: background-color 180ms ease;
}

.only-category__card:hover {
  transform: translateY(-3px);
  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
}

.only-category__card:hover::before {
  background-color: rgba(8, 15, 11, 0.12);
}

.only-category__card:focus-visible {
  outline: 3px solid #7da38a;
  outline-offset: 3px;
}

.only-category__image {
  position: absolute;
  z-index: 0;
  inset: 0;
  width: 100%;
  height: 100%;
  background-color: #293b30;
  background-position: center;
  background-size: cover;
  filter: none;
  transform: scale(1.01);
  transition: transform 450ms cubic-bezier(0.2, 0.7, 0.2, 1);
}

.only-category__card:hover .only-category__image {
  transform: scale(1.07);
}

.only-category__content {
  position: relative;
  z-index: 2;
  display: grid;
  width: 100%;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
  gap: 0.45rem 0.75rem;
}

.only-category__eyebrow {
  grid-column: 1 / -1;
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.66rem;
  font-weight: 750;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.only-category .only-category__title {
  margin: 0;
  color: #fff;
  font-size: clamp(1.15rem, 2.35vw, 2rem);
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.08;
  text-align: left !important;
  text-wrap: balance;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
}

.only-category__arrow {
  display: inline-flex;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.46);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 1rem;
  backdrop-filter: blur(8px);
  transition: background-color 180ms ease, transform 180ms ease;
}

.only-category__card:hover .only-category__arrow {
  background: rgba(255, 255, 255, 0.24);
  transform: translate(2px, -2px);
}

.only-category__card--showcase {
  min-height: 134px;
  align-items: center;
  padding: 0.65rem 0.8rem 0.65rem 0;
  border: 0;
  border-radius: 28px;
  background-color: #ffd8e5;
  background-image: radial-gradient(rgba(220, 126, 157, 0.12) 1px, transparent 1px);
  background-position: 8px 8px;
  background-size: 22px 22px;
  box-shadow: 0 8px 20px rgba(144, 71, 96, 0.08);
}

.only-category__card--showcase::before {
  background: transparent;
}

.only-category__card--showcase .only-category__image {
  inset: 5px auto 5px 5px;
  width: 37%;
  background-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.only-category__card--showcase .only-category__content {
  display: flex;
  width: 63%;
  margin-left: 37%;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  text-align: center;
}

.only-category .only-category__card--showcase .only-category__title {
  color: #29252a;
  font-size: clamp(0.88rem, 1.2vw, 1.08rem);
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.2;
  text-align: center !important;
  text-shadow: none;
}

.only-category__all-link {
  color: #67545d;
  font-size: clamp(0.8rem, 1.1vw, 1rem);
  line-height: 1.25;
}

.only-category__all-link span {
  display: inline-block;
  margin-left: 0.1rem;
  font-size: 1.2em;
  transition: transform 180ms ease;
}

.only-category__card--showcase:hover .only-category__all-link span {
  transform: translateX(3px);
}

@media (max-width: 767.98px) {
  .only-category__column {
    padding: 0.35rem 0.5rem;
  }

  .only-category__card {
    min-height: 165px;
    border-radius: 16px;
  }

  .only-category__card--showcase {
    min-height: 116px;
    border-radius: 22px;
  }

  .only-category__card--showcase .only-category__image {
    width: 36%;
  }

  .only-category__card--showcase .only-category__content {
    width: 64%;
    margin-left: 36%;
  }

  .only-category .only-category__title {
    font-size: clamp(1.1rem, 5vw, 1.55rem);
  }
}

@media (prefers-reduced-motion: reduce) {
  .only-category__card,
  .only-category__image,
  .only-category__arrow {
    transition: none;
  }
}
</style>
